export const ADDING_ID = 'ADDING';

export function suggestAdding(risk) {
  return risk <= 0.5;
}
